import Request from './Request'

function queryString(params = {}) {
  const query = new URLSearchParams(Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== ''))
  const result = query.toString()
  return result ? `?${result}` : ''
}

export default class ClientDashboardNotificationService {
  static async listForClient(clientId) {
    const response = await Request.get(`/api/client-dashboard-notifications${queryString({ client_id: clientId })}`)
    return response?.data || { advisor: [], journey: [], event: [] }
  }

  static async list(params = {}) {
    const response = await Request.get(`/api/admin/client-notifications${queryString(params)}`)
    return Array.isArray(response?.data) ? response.data : []
  }

  static create(data) {
    return Request.post('/api/admin/client-notifications', data)
  }

  static update(id, data) {
    return Request.post(`/api/admin/client-notifications/${id}`, data)
  }

  static remove(id) {
    return Request._delete(`/api/admin/client-notifications/${id}`)
  }
}

